export default {"src":"/_next/static/media/rocket.fade0bff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};